import { useEffect, useRef } from "react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";

export const CatalogModelUpload = ({ value, busy, onBusy, onChange }) => {
  const pending = useRef(null);
  useEffect(() => () => pending.current?.abort(), []);

  const choose = async event => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    if (!/\.(stl|obj)$/i.test(file.name)) return toast.error("Choose an STL or OBJ model.");
    if (file.size > 90 * 1024 * 1024) return toast.error("Model must be under 90 MB for this uploader.");
    pending.current?.abort();
    const controller = new AbortController();
    pending.current = controller;
    const form = new FormData();
    form.append("file", file);
    onBusy(true);
    try {
      const { data } = await api.post("/prints/upload", form, { signal: controller.signal });
      if (!controller.signal.aborted) onChange(data);
    } catch (error) {
      if (!controller.signal.aborted) toast.error(apiError(error, "Model upload failed."));
    } finally {
      if (!controller.signal.aborted) onBusy(false);
    }
  };

  return <div className="min-w-0 space-y-2">
    <label htmlFor="catalog-model-file" className="text-xs text-white/70">3D model · STL / OBJ</label>
    {value?.file_name && <p data-testid="admin-catalog-model-name" className="text-xs text-emerald-300 break-all">{value.file_name}</p>}
    <input id="catalog-model-file" data-testid="admin-catalog-model-input" type="file" accept=".stl,.obj"
      disabled={busy} onChange={choose} className="block w-full min-w-0 max-w-full text-xs text-white/70 file:mr-2 file:border-0 file:rounded file:px-2 file:py-2 file:bg-white/10 file:text-white" />
    {busy && <p data-testid="admin-catalog-model-loading" role="status" className="text-xs text-white/60">Uploading model…</p>}
  </div>;
};